(function($) {
    'use strict';
    var Tabs = function(el) {
        this.$el = $(el);
        this.$tabs = this.$el.find('.tab:eq(0)').siblings('.tab').addBack();
        this.$content = this.$el
            .find('.tab-content:eq(0)')
            .siblings('.tab-content')
            .addBack();
        this.settings = $.extend(
            {
                showFirst: true
            },
            this.settings,
            this.$el.data()
        );
        this.init();
    };
    Tabs.prototype = {
        $activeTab: null,
        init: function() {
            var that = this;
            if (window.location.hash) {
                var $tab = $(window.location.hash),
                    tabID = $tab.attr('href');
                that.$tabs.removeClass('active');
                $tab.parent().addClass('active');
                that.show(tabID);
            }
            if (that.$tabs.filter('.active').length === 0) {
                if (this.settings.showFirst) {
                    that.$tabs.first().addClass('active');
                    that.$activeTab = that.$content.eq(0).addClass('active');
                    $.event.trigger('tabs.changed', {
                        show: that.$tabs.first()
                    });
                }
            } else {
                var openId = that.$tabs.filter('.active').find('a').attr('href');
                that.$activeTab = $(openId);
                that.show(openId);
            }
            that.bindEvents();
            that.sameSizeTabs();
        },
        bindEvents: function() {
            var that = this;
            that.$tabs.find('a').on('click', function(e) {
                var $tab = $(this),
                    tabID = $tab.attr('href');
                that.$tabs.removeClass('active');
                $tab.parent().addClass('active');
                that.show(tabID);
                e.preventDefault();
            });
            $(window).on('resize', function() {
                that.sameSizeTabs();
            });
        },
        sameSizeTabs: function() {
            var that = this,
                height = 0,
                $tab;
            that.$tabs.height('auto');
            that.$tabs.each(function() {
                $tab = $(this);
                if ($tab.height() > height) {
                    height = $tab.height();
                }
            });
            that.$tabs.height(height);
        },
        show: function(id) {
            var that = this,
                $show = $(id + ', ' + id + '-content'),
                $hide = that.$activeTab;
            if ($hide) {
                $hide.removeClass('active');
            }
            $show.addClass('active');
            that.$activeTab = $show;
            $.event.trigger('tabs.changed', {
                show: $show,
                hide: $hide
            });
        }
    };
    $.fn.tabs = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('tabs');
            if (!data) {
                $this.data('tabs', (data = new Tabs(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };
    $.fn.tabs.Constructor = Tabs;
})(jQuery);
